const fmtPad = (n) => String(n).padStart(2, '0');

/**
 * NumeriImportanti — colonna sinistra della GRID dashboard.
 * Lista "north-star metrics" definite dall'utente per l'anno.
 *
 * Props:
 *   - items : array di { id, ordine, metrica, descrizione }
 */
export default function NumeriImportanti({ items }) {
  return (
    <div className="md:col-span-5 lg:col-span-4 md:border-r md:border-line md:pr-12">
      <div className="mono-label mb-6">Numeri importanti</div>
      {items.length === 0 ? (
        <p className="font-body text-sm text-mute italic">Nessun north-star definito.</p>
      ) : (
        <div className="space-y-8">
          {items.map((n, idx) => (
            <div key={n.id} className="border-t border-line pt-6" data-testid="kpi-metric-item">
              <div className="flex items-baseline justify-between mb-1">
                <span className="font-mono text-xs text-mute">{fmtPad(n.ordine || idx + 1)}</span>
                <span className="font-mono text-xs uppercase tracking-[0.15em] text-soft">
                  {n.metrica || '—'}
                </span>
              </div>
              {/* Titoli north-star: dimensione ridotta rispetto al mono_massive originale
                  per lasciare più spazio verticale e ridurre l'overflow con testi lunghi. */}
              <div className="font-mono font-light text-xl md:text-2xl lg:text-3xl tracking-tight leading-tight break-words">
                {n.descrizione}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
